// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolTipButton {
  border: none;
  background: transparent;
}
.toolTipButton:hover {
  cursor: pointer;
}
.customScroll::-webkit-scrollbar-track {
  background-color: red !important;
}

/* LOADER FROM VUE */
.icon-loader-wrap {
  position: relative;
  display: inline-block;
  text-align: center;
  display: flex;
  align-items: center;
  margin: 0 auto;
}

.logo-image-svg {
  position: absolute;
  background: transparent;
}

#svg {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  fill: #252525;
  width: 70% !important;
  height: 100%;
}

.icon-loader-wrap path:nth-child(1) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.05s;
}
.icon-loader-wrap path:nth-child(2) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.1s;
}
.icon-loader-wrap path:nth-child(3) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.15s;
}
.icon-loader-wrap path:nth-child(4) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.2s;
}
.icon-loader-wrap path:nth-child(5) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.25s;
}
.icon-loader-wrap path:nth-child(6) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.3s;
}
.icon-loader-wrap path:nth-child(7) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.35s;
}
.icon-loader-wrap path:nth-child(8) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.4s;
}
.icon-loader-wrap path:nth-child(9) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.45s;
}
.icon-loader-wrap path:nth-child(10) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.5s;
}

.icon-loader-wrap path:nth-child(11) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.65s;
}
.icon-loader-wrap path:nth-child(12) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.6s;
}
.icon-loader-wrap path:nth-child(13) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.65s;
}
.icon-loader-wrap path:nth-child(14) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.7s;
}
.icon-loader-wrap path:nth-child(15) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.75s;
}
.icon-loader-wrap path:nth-child(16) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.8s;
}
.icon-loader-wrap path:nth-child(17) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.85s;
}
.icon-loader-wrap path:nth-child(18) {
  animation: pweek 1s linear infinite;
  animation-delay: 0.9s;
}

@keyframes pweek {
  0% {
    fill: #e6616a;
  }
  20% {
    fill: #252525;
  }
  40% {
    fill: #e6616a;
  }
  60% {
    fill: #252525;
  }
  80% {
    fill: #e6616a;
  }
  100% {
    fill: #252525;
  }
}
`, "",{"version":3,"sources":["webpack://./../../../libs/html/components/build/assets/components.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".toolTipButton {\n  border: none;\n  background: transparent;\n}\n.toolTipButton:hover {\n  cursor: pointer;\n}\n.customScroll::-webkit-scrollbar-track {\n  background-color: red !important;\n}\n\n/* LOADER FROM VUE */\n.icon-loader-wrap {\n  position: relative;\n  display: inline-block;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n}\n\n.logo-image-svg {\n  position: absolute;\n  background: transparent;\n}\n\n#svg {\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  fill: #252525;\n  width: 70% !important;\n  height: 100%;\n}\n\n.icon-loader-wrap path:nth-child(1) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.05s;\n}\n.icon-loader-wrap path:nth-child(2) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.1s;\n}\n.icon-loader-wrap path:nth-child(3) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.15s;\n}\n.icon-loader-wrap path:nth-child(4) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.2s;\n}\n.icon-loader-wrap path:nth-child(5) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.25s;\n}\n.icon-loader-wrap path:nth-child(6) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.3s;\n}\n.icon-loader-wrap path:nth-child(7) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.35s;\n}\n.icon-loader-wrap path:nth-child(8) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.4s;\n}\n.icon-loader-wrap path:nth-child(9) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.45s;\n}\n.icon-loader-wrap path:nth-child(10) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.5s;\n}\n\n.icon-loader-wrap path:nth-child(11) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.65s;\n}\n.icon-loader-wrap path:nth-child(12) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.6s;\n}\n.icon-loader-wrap path:nth-child(13) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.65s;\n}\n.icon-loader-wrap path:nth-child(14) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.7s;\n}\n.icon-loader-wrap path:nth-child(15) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.75s;\n}\n.icon-loader-wrap path:nth-child(16) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.8s;\n}\n.icon-loader-wrap path:nth-child(17) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.85s;\n}\n.icon-loader-wrap path:nth-child(18) {\n  animation: pweek 1s linear infinite;\n  animation-delay: 0.9s;\n}\n\n@keyframes pweek {\n  0% {\n    fill: #e6616a;\n  }\n  20% {\n    fill: #252525;\n  }\n  40% {\n    fill: #e6616a;\n  }\n  60% {\n    fill: #252525;\n  }\n  80% {\n    fill: #e6616a;\n  }\n  100% {\n    fill: #252525;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
